var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"live-top-tag-list"},[(_setup.hasLive)?_c('span',{staticClass:"live-tag"},[_c('div',{staticClass:"dot",class:{ animate: _vm.animate }}),_vm._v("\n    LIVE\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }